export const PRODUCT_TYPE_OL = "OPERATING_LEASING";
